import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/wxww.png';
import _imports_1 from '@/assets/new/wxpay_tip-ac45fc3d17795a22330c.png';
const _withScopeId = n => (_pushScopeId("data-v-1faf3d79"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "paymyyik"
};
const _hoisted_2 = {
  class: "haert"
};
const _hoisted_3 = {
  class: "haert_100px"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "haert_2"
};
const _hoisted_6 = {
  style: {
    "font-size": "20px"
  }
};
const _hoisted_7 = {
  style: {
    "margin-top": "5px"
  }
};
const _hoisted_8 = {
  key: 0,
  style: {
    "font-size": "15px",
    "font-weight": "400"
  }
};
const _hoisted_9 = {
  key: 1,
  style: {
    "font-size": "15px",
    "font-weight": "400"
  }
};
const _hoisted_10 = {
  key: 2,
  style: {
    "font-size": "15px",
    "font-weight": "400"
  }
};
const _hoisted_11 = {
  key: 3,
  style: {
    "font-size": "15px",
    "font-weight": "400"
  }
};
const _hoisted_12 = {
  key: 4,
  style: {
    "font-size": "15px",
    "font-weight": "400"
  }
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "haert_1"
}, null, -1));
const _hoisted_14 = {
  class: "membership-types"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-size": "clamp(8px, 1.8vw, 15px)",
    "color": "#878383"
  }
}, " 不限次数 包年使用 ", -1));
const _hoisted_17 = {
  key: 0,
  class: "pricedd"
};
const _hoisted_18 = {
  key: 1,
  class: "price-green"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "font-size": "clamp(10px, 1.5vw, 15px)",
    "color": "#000"
  }
}, " 升级 ", -1));
const _hoisted_20 = {
  style: {
    "text-decoration": "line-through",
    "font-size": "clamp(10px, 1.5vw, 15px)",
    "color": "#ccc"
  }
};
const _hoisted_21 = {
  key: 2,
  class: "pricedd"
};
const _hoisted_22 = {
  key: 3,
  t: "1739605100915",
  class: "icon",
  style: {
    "position": "absolute",
    "top": "0",
    "right": "0"
  },
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5112",
  width: "50",
  height: "50"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M614.22592 0H28.53888L19.34848 9.1904 1024 1013.84704V409.77408L614.22592 0z m223.17568 526.49472l-17.62304 3.52256c-6.67648-23.74656-12.61568-38.58432-24.29952-61.02528l17.24928-2.78528c12.24704 24.12032 18.37056 39.1424 24.67328 60.288zM408.29952 263.59808c-42.10688-42.10688-54.53824-57.13408-57.68704-69.93408-2.04288-7.23456 0.7424-13.35296 10.38848-22.99904l82.176-82.176c10.20416-10.20416 14.65344-15.0272 19.29216-21.51936l14.46912 14.46912c-5.9392 4.4544-11.87328 9.64608-21.51936 19.29216l-14.09536 14.09536 101.65248 101.65248 48.9728-48.9728-97.20832-97.19296c-9.8304-9.8304-16.69632-15.95392-23.00416-20.77696l13.91104-13.91104c4.63872 6.12352 10.5728 12.8 20.77696 22.99904l88.48384 88.47872c8.71936 8.71936 15.02208 14.65344 22.44608 20.59264-5.74976 4.63872-11.13088 9.64608-18.73408 17.24928l-37.28384 37.28384c-9.46176 9.46176-13.72672 14.10048-17.43872 18.92352-6.86592-7.60832-15.39584-16.88064-18.9184-20.4032l-0.55808-0.55808-94.41792-94.04416-53.6064 53.6064c-6.49216 6.49216-8.16128 10.38848-6.30784 15.21152 3.52256 9.088 12.61568 19.29216 49.52576 56.20736 44.33408 44.33408 52.86912 51.01056 62.88384 48.78848 5.93408-1.4848 20.4032-11.87328 33.76128-24.48384 1.66912 6.12352 4.26496 11.3152 8.3456 16.88064-22.44608 18.36544-33.9456 25.41568-43.22304 26.52672-13.53728 1.29024-25.22624-7.42912-73.08288-55.28576z m97.13152 110.11584c0.7424-7.41888 0.7424-9.64608-0.36864-17.80736 23.3728 4.82304 36.72576 4.82304 51.56864-0.37376s32.27648-18.18112 54.72256-40.62208l31.90784-31.90784c13.72672-13.72672 17.06496-17.43872 22.81472-25.04192l12.61568 12.61568c-6.49216 5.38112-14.09536 12.61568-24.29952 22.81472l-32.27648 32.27648c-28.01152 28.01152-46.18752 40.62208-65.664 46.37184-15.5904 4.45952-28.75904 5.0176-51.0208 1.67424z m75.12576 49.89952l-17.4336-2.9696c5.74976-16.13824 9.088-29.12256 11.86816-47.85664l14.65344 3.15392c-1.47968 12.98432-5.74464 34.31936-9.088 47.67232z m15.95392-49.34144c5.38112-4.26496 10.75712-9.27232 17.99168-16.50688l89.0368-89.0368-35.05664-35.06176-89.59488 89.59488c-7.05024 7.05024-11.49952 11.87328-16.13824 17.2544l-12.0576-12.0576c5.19168-4.4544 10.5728-9.46176 17.24928-16.13824l82.9184-82.9184c7.23456-7.23456 12.0576-12.42624 16.69632-18.18112 4.82304 5.56544 7.6032 8.71936 15.58016 16.69632l28.01152 28.01152c5.56544 5.56544 10.5728 10.20416 14.83776 13.35808-4.63872 3.89632-10.94656 9.8304-17.62304 16.50688L625.8176 368.33792c-8.16128 8.16128-12.24192 12.61568-16.88064 18.36544l-12.42624-12.43136z m71.22944 45.2608c4.4544 3.33824 13.35808 8.90368 18.18112 11.87328 5.9392-12.24192 10.01984-21.888 14.65344-36.54144l13.35296 5.19168c-8.71936 25.41568-15.58016 40.43776-30.2336 67.33312l-15.0272-5.38112c5.56544-8.90368 6.67648-10.75712 10.94656-18.36544l-1.85344-1.11104a389.12 389.12 0 0 1-29.12256-19.10784c-8.3456-6.12352-21.1456-14.46912-30.2336-20.21888l8.71936-12.8c6.30784 3.33824 10.75712 3.33824 18.18112 0 6.86592-2.78016 32.4608-16.88064 44.89216-24.48384 9.64608-5.93408 14.46912-9.27232 22.99904-15.95392l9.46176 15.0272c-3.52768 1.66912-3.52768 1.66912-38.95296 21.888-11.68384 6.49216-14.83776 8.16128-37.09952 18.18112 4.99712 3.15392 4.99712 3.15392 21.13536 14.46912z m-12.98432 88.66816c-5.93408-0.7424-12.8-5.38112-22.26176-14.83776-4.26496-4.26496-11.3152-12.0576-20.4032-22.6304 4.26496-5.00736 6.67648-9.27232 9.46176-15.39584 7.97696 11.3152 16.32256 21.1456 23.18848 28.01152 7.6032 7.60832 10.75712 8.90368 15.95392 7.05024 17.62304-6.8608 63.06816-44.89216 120.20224-100.91008L721.90464 330.496a196.00896 196.00896 0 0 1-51.56864 11.87328c0.7424-5.93408 0.36864-10.01984-0.92672-16.50688 21.888-1.11104 42.48064-6.86592 64.55296-17.43872 11.68896-5.74976 20.77696-11.13088 27.26912-16.50688l9.64608 15.95392c-2.59584 1.11104-5.56544 2.59584-13.35296 6.30784-8.71936 4.63872-11.68896 6.12352-20.96128 10.20416l50.82624 50.82624c7.05024 7.05024 11.68896 11.3152 17.06496 15.58016-4.63872 3.52256-7.6032 6.12352-15.21152 13.72672-44.88704 43.40736-78.83776 73.27232-103.50592 90.5216-14.10048 9.64096-23.93088 13.90592-30.98112 13.16352z m190.80704 202.30656c-8.90368-35.24608-18.73408-63.62624-35.4304-102.95296l16.32256-3.70688c16.88064 38.39488 27.07968 66.4064 37.84192 103.13728l-18.73408 3.52256z m51.56864-81.98656c10.38848 10.38848 15.76448 15.39584 21.888 19.6608l-13.72672 13.72672c-5.38112-6.86592-11.13088-13.35808-19.6608-21.888l-52.1216-52.1216c-24.8576 12.61568-45.81888 13.5424-77.16864 2.9696-20.77696-7.05024-37.28384-15.7696-63.81056-33.01888 2.78016-6.86592 4.08064-12.98432 3.89632-20.21888 27.82208 21.1456 46.92992 31.34976 71.97184 38.58432 21.70368 6.12352 35.79904 5.74976 52.1216-1.30048L763.392 517.78048c-9.64608-9.64608-15.58528-14.83776-21.33504-19.10784l13.72672-13.72672c4.08064 5.56544 9.46176 11.68384 19.10784 21.32992l60.288 60.288c12.42624-7.97696 36.35712-28.19584 52.86912-44.70272 8.16128-8.16128 12.61568-13.72672 15.95392-18.9184l15.21152 15.21152c-5.56544 4.08064-9.8304 7.60832-18.73408 16.13824-16.13824 15.76448-35.24096 31.90784-52.864 44.70272l49.51552 49.52576z m-58.8032-173.44l16.69632-2.2272c9.8304 20.58752 15.0272 35.05664 21.1456 57.87136l-16.88064 3.89632c-5.93408-24.48384-10.38336-37.0944-20.96128-59.54048z m159.34464 107.776c-2.78016 0.92672-2.78016 0.92672-12.42624 5.38112-13.16864 6.49216-29.86496 12.42624-46.92992 16.50688-1.85344-8.16128-2.9696-10.75712-7.05024-17.06496 15.39584-2.41152 28.7488-6.86592 45.62944-14.83776l-116.1216-116.1216c-9.64608-9.64608-15.58016-14.83776-21.33504-19.10784l13.5424-13.5424c4.08064 5.56544 9.46176 11.68384 19.10784 21.32992l107.77088 107.776c10.5728 10.5728 13.16864 12.8 17.99168 16.13824l-0.1792 13.5424z",
  fill: "#e16531",
  "p-id": "5113"
}, null, -1));
const _hoisted_24 = [_hoisted_23];
const _hoisted_25 = {
  class: "container"
};
const _hoisted_26 = {
  class: "row"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "套餐包含:", -1));
const _hoisted_28 = {
  class: "box-container"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "background": "#ffffff",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "top": "-10px",
    "right": "-10px",
    "border-radius": "50%"
  }
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1739356020673",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4228",
  width: "24",
  height: "24"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M511.999994 0C229.205543 0 0.020822 229.226376 0.020822 512.020827c0 282.752797 229.184721 511.979173 511.979173 511.979173s511.979173-229.226376 511.979173-511.979173C1023.979167 229.226376 794.794446 0 511.999994 0zM815.371918 318.95082l-346.651263 461.201969c-10.830249 14.370907-27.32555 23.409999-45.27877 24.742952-1.582882 0.124964-3.12411 0.166619-4.665338 0.166619-16.328682 0-32.074198-6.373185-43.779197-17.911565l-192.903389-189.44604c-24.617988-24.20144-24.992881-63.731847-0.791441-88.349835 24.20144-24.659643 63.731847-24.951226 88.349835-0.833096l142.042875 139.501932 303.788472-404.2182c20.744091-27.575479 59.899605-33.115568 87.516739-12.413131C830.534266 252.219827 836.116009 291.375341 815.371918 318.95082z",
  fill: "#7a59ff",
  "p-id": "4229"
})])], -1));
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  class: "title"
};
const _hoisted_32 = {
  class: "price"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "background": "#ffffff",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "top": "-10px",
    "right": "-10px",
    "border-radius": "50%"
  }
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1739356020673",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4228",
  width: "24",
  height: "24"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M511.999994 0C229.205543 0 0.020822 229.226376 0.020822 512.020827c0 282.752797 229.184721 511.979173 511.979173 511.979173s511.979173-229.226376 511.979173-511.979173C1023.979167 229.226376 794.794446 0 511.999994 0zM815.371918 318.95082l-346.651263 461.201969c-10.830249 14.370907-27.32555 23.409999-45.27877 24.742952-1.582882 0.124964-3.12411 0.166619-4.665338 0.166619-16.328682 0-32.074198-6.373185-43.779197-17.911565l-192.903389-189.44604c-24.617988-24.20144-24.992881-63.731847-0.791441-88.349835 24.20144-24.659643 63.731847-24.951226 88.349835-0.833096l142.042875 139.501932 303.788472-404.2182c20.744091-27.575479 59.899605-33.115568 87.516739-12.413131C830.534266 252.219827 836.116009 291.375341 815.371918 318.95082z",
  fill: "#7a59ff",
  "p-id": "4229"
})])], -1));
const _hoisted_34 = ["src"];
const _hoisted_35 = ["src"];
const _hoisted_36 = ["src"];
const _hoisted_37 = ["src"];
const _hoisted_38 = ["src"];
const _hoisted_39 = ["src"];
const _hoisted_40 = {
  class: "title"
};
const _hoisted_41 = {
  class: "price"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "background": "#ffffff",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "top": "-10px",
    "right": "-10px",
    "border-radius": "50%"
  }
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1739356020673",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4228",
  width: "24",
  height: "24"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M511.999994 0C229.205543 0 0.020822 229.226376 0.020822 512.020827c0 282.752797 229.184721 511.979173 511.979173 511.979173s511.979173-229.226376 511.979173-511.979173C1023.979167 229.226376 794.794446 0 511.999994 0zM815.371918 318.95082l-346.651263 461.201969c-10.830249 14.370907-27.32555 23.409999-45.27877 24.742952-1.582882 0.124964-3.12411 0.166619-4.665338 0.166619-16.328682 0-32.074198-6.373185-43.779197-17.911565l-192.903389-189.44604c-24.617988-24.20144-24.992881-63.731847-0.791441-88.349835 24.20144-24.659643 63.731847-24.951226 88.349835-0.833096l142.042875 139.501932 303.788472-404.2182c20.744091-27.575479 59.899605-33.115568 87.516739-12.413131C830.534266 252.219827 836.116009 291.375341 815.371918 318.95082z",
  fill: "#7a59ff",
  "p-id": "4229"
})])], -1));
const _hoisted_43 = ["src"];
const _hoisted_44 = {
  class: "title"
};
const _hoisted_45 = {
  class: "price"
};
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "background": "#ffffff",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "top": "-10px",
    "right": "-10px",
    "border-radius": "50%"
  }
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1739605782559",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "9853",
  width: "24",
  height: "24"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M511.999994 0C229.205543 0 0.020822 229.226376 0.020822 512.020827c0 282.752797 229.184721 511.979173 511.979173 511.979173s511.979173-229.226376 511.979173-511.979173C1023.979167 229.226376 794.794446 0 511.999994 0zM815.371918 318.95082l-346.651263 461.201969c-10.830249 14.370907-27.32555 23.409999-45.27877 24.742952-1.582882 0.124964-3.12411 0.166619-4.665338 0.166619-16.328682 0-32.074198-6.373185-43.779197-17.911565l-192.903389-189.44604c-24.617988-24.20144-24.992881-63.731847-0.791441-88.349835 24.20144-24.659643 63.731847-24.951226 88.349835-0.833096l142.042875 139.501932 303.788472-404.2182c20.744091-27.575479 59.899605-33.115568 87.516739-12.413131C830.534266 252.219827 836.116009 291.375341 815.371918 318.95082z",
  fill: "#faa178",
  "p-id": "9854"
})])], -1));
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "title"
};
const _hoisted_49 = {
  class: "price"
};
const _hoisted_50 = {
  key: 0,
  class: "row"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "更多模块:", -1));
const _hoisted_52 = {
  class: "box-container"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  style: {
    "background": "#ffffff",
    "position": "absolute",
    "display": "flex",
    "align-items": "center",
    "top": "-10px",
    "right": "-10px",
    "border-radius": "50%"
  }
};
const _hoisted_55 = {
  key: 0,
  t: "1739356020673",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4228",
  width: "24",
  height: "24"
};
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M511.999994 0C229.205543 0 0.020822 229.226376 0.020822 512.020827c0 282.752797 229.184721 511.979173 511.979173 511.979173s511.979173-229.226376 511.979173-511.979173C1023.979167 229.226376 794.794446 0 511.999994 0zM815.371918 318.95082l-346.651263 461.201969c-10.830249 14.370907-27.32555 23.409999-45.27877 24.742952-1.582882 0.124964-3.12411 0.166619-4.665338 0.166619-16.328682 0-32.074198-6.373185-43.779197-17.911565l-192.903389-189.44604c-24.617988-24.20144-24.992881-63.731847-0.791441-88.349835 24.20144-24.659643 63.731847-24.951226 88.349835-0.833096l142.042875 139.501932 303.788472-404.2182c20.744091-27.575479 59.899605-33.115568 87.516739-12.413131C830.534266 252.219827 836.116009 291.375341 815.371918 318.95082z",
  fill: "#7a59ff",
  "p-id": "4229"
}, null, -1));
const _hoisted_57 = [_hoisted_56];
const _hoisted_58 = {
  key: 1,
  t: "1739356020673",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "4228",
  width: "24",
  height: "24"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M511.999994 0C229.205543 0 0.020822 229.226376 0.020822 512.020827c0 282.752797 229.184721 511.979173 511.979173 511.979173s511.979173-229.226376 511.979173-511.979173C1023.979167 229.226376 794.794446 0 511.999994 0zM815.371918 318.95082l-346.651263 461.201969c-10.830249 14.370907-27.32555 23.409999-45.27877 24.742952-1.582882 0.124964-3.12411 0.166619-4.665338 0.166619-16.328682 0-32.074198-6.373185-43.779197-17.911565l-192.903389-189.44604c-24.617988-24.20144-24.992881-63.731847-0.791441-88.349835 24.20144-24.659643 63.731847-24.951226 88.349835-0.833096l142.042875 139.501932 303.788472-404.2182c20.744091-27.575479 59.899605-33.115568 87.516739-12.413131C830.534266 252.219827 836.116009 291.375341 815.371918 318.95082z",
  fill: "#7a59ff",
  "p-id": "4229"
}, null, -1));
const _hoisted_60 = [_hoisted_59];
const _hoisted_61 = ["src"];
const _hoisted_62 = ["src"];
const _hoisted_63 = ["src"];
const _hoisted_64 = ["src"];
const _hoisted_65 = ["src"];
const _hoisted_66 = ["src"];
const _hoisted_67 = {
  class: "title"
};
const _hoisted_68 = {
  class: "price"
};
const _hoisted_69 = {
  class: "erwwl"
};
const _hoisted_70 = {
  class: "erwwl_1"
};
const _hoisted_71 = {
  style: {
    "color": "#ff7200"
  }
};
const _hoisted_72 = {
  key: 0
};
const _hoisted_73 = {
  key: 0
};
const _hoisted_74 = {
  style: {
    "color": "#ff7200",
    "font-size": "25px"
  }
};
const _hoisted_75 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {
    "color": "#ff7200"
  }
}, "元", -1));
const _hoisted_76 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-decoration": "line-through",
    "color": "#ccc"
  }
}, null, -1));
const _hoisted_77 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "立即购买", -1));
const _hoisted_78 = [_hoisted_77];
const _hoisted_79 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "立即购买", -1));
const _hoisted_80 = [_hoisted_79];
const _hoisted_81 = {
  class: "order-info"
};
const _hoisted_82 = {
  class: "order-item"
};
const _hoisted_83 = {
  class: "order-number"
};
const _hoisted_84 = {
  class: "order-item"
};
const _hoisted_85 = {
  class: "amount"
};
const _hoisted_86 = {
  class: "payment-method"
};
const _hoisted_87 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "payment-title"
}, "支付方式：", -1));
const _hoisted_88 = {
  class: "payment-options"
};
const _hoisted_89 = {
  class: "payment-option wechat-pay selected"
};
const _hoisted_90 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "微信支付",
  class: "payment-icon"
}, null, -1));
const _hoisted_91 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "payment-text"
}, "微信支付", -1));
const _hoisted_92 = {
  class: "qr-code-section"
};
const _hoisted_93 = {
  class: "qr-code-left"
};
const _hoisted_94 = ["src"];
const _hoisted_95 = {
  t: "1739427619564",
  class: "icon",
  style: {
    "margin": "10px 0"
  },
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "6034",
  width: "48",
  height: "48"
};
const _hoisted_96 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M512 0c282.784 0 512 229.216 512 512s-229.216 512-512 512S0 794.784 0 512 229.216 0 512 0z m40.224 659.52a56.896 56.896 0 1 0-80.448 80.448 56.896 56.896 0 0 0 80.448-80.448zM563.2 284.448h-102.4v307.2h102.4v-307.2z",
  fill: "#FDA72E",
  "p-id": "6035"
}, null, -1));
const _hoisted_97 = [_hoisted_96];
const _hoisted_98 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  style: {
    "font-weight": "700"
  }
}, "二维码已过期，点击刷新", -1));
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "qr-code-text"
}, "请打开手机微信，扫一扫完成支付", -1));
const _hoisted_100 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "phone-tip"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "微信扫码提示",
  class: "phone-tip-img"
})], -1));
const _hoisted_101 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "asdasd"
}, [/*#__PURE__*/_createElementVNode("svg", {
  t: "1739437888774",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "5208",
  width: "100",
  height: "100"
}, [/*#__PURE__*/_createElementVNode("path", {
  d: "M501.009067 0C224.50176 0 0.395947 229.198507 0.395947 512s224.105813 512 500.626773 512c276.514133 0 500.619947-229.198507 500.619947-512S777.434453 0 501.015893 0z m-39.103147 732.99968L257.938773 514.300587l52.210347-44.305067L428.168533 567.405227c48.011947-60.299947 155.56608-180.599467 303.506774-276.39808l12.417706 30.399146c-135.816533 131.50208-247.186773 316.798293-282.187093 411.600214z",
  fill: "#06B464",
  "p-id": "5209"
})]), /*#__PURE__*/_createElementVNode("p", {
  style: {
    "margin": "10px",
    "font-size": "35px"
  }
}, "支付成功")], -1));
import { ref, onMounted, computed, nextTick } from "vue";
import { ordersnewsubget, ordersmodelget, paywechat, getordersts, ordersswitchingpost } from "@/api/indd";
import toolsdsd from "@/assets/xingl/microscope.png";
import asdas from "@/assets/xingl/asdas.png";
import observation from "@/assets/Teacher.png";
import proofreader from "@/assets/writing.png";
import raina from "@/assets/foreignteacher.png";
import bunz from "@/assets/xingl/palette.png";
import wand from "@/assets/xingl/stickynotes.png";
import resources from "@/assets/xingl/courses.png";
import potion from "@/assets/xingl/Medal.png";
import questions from "@/assets/xingl/bus.png";
import chatbot from "@/assets/xingl/student.png";
import suggestion from "@/assets/xingl/Bookshelf.png";
import stories from "@/assets/xingl/rubber.png";
import generator from "@/assets/xingl/Female.png";
import explanations from "@/assets/xingl/Books.png";
import swdtsna from "@/assets/xingl/yusdasdas.png";

/*
 *
 *
 *四个套餐
 */
// 会员类型数据 (你需要替换成你自己的数据和图标路径)

import ruler from '@/assets/xingl/ruler.png';
import dasdas from '@/assets/xingl/dasdas.png';
import asdasdf from '@/assets/xingl/asdasdf.png';
import stickynotes from '@/assets/xingl/stickynotes.png';
import asdasddd from "@/assets/xingl/asdas.png";
import { ElIcon } from "element-plus";
import { ArrowUp, ArrowDown, Check } from "@element-plus/icons-vue";
import { ElCollapseTransition } from "element-plus";

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  __name: 'Payment copy',
  setup(__props) {
    const grow_up = ref();
    const name = ref();
    const haye = ref();
    onMounted(() => {
      haye.value = localStorage.getItem('haye');
      name.value = localStorage.getItem('name');
      moniin();
    });

    // 开始执行内容
    const moniin = () => {
      grow_up.value = localStorage.getItem("grow_up");
      // grow_up.value = 2;
      ordersnewsubget().then(res => {
        membershipList.value = res.message;
        hjksfk();
      });
      ordersmodelget().then(res => {
        items.value = res.message;
      });
    };
    // 判断开始展示默认套餐内容，和指向的套餐
    const hjksfk = () => {
      if (grow_up.value == 4) {
        selectedIndex.value = 3;
        disabledIndices.value = membershipList.value[3].sub_model;
        taoc_price.value = membershipList.value[3].price;
        sj.value = membershipList.value[3].sj;
        disab_permission.value = membershipList.value[3].permission;
      } else {
        selectedIndex.value = 2;
        disabledIndices.value = membershipList.value[2].sub_model;
        taoc_price.value = membershipList.value[2].price;
        sj.value = membershipList.value[2].sj;
        disab_permission.value = membershipList.value[2].permission;
      }
    };
    //判断展示用户购买的内容
    const dhjsfg = a => {
      const isDisabled = disab_permission.value.includes(a.sub_model[0]);
      if (isDisabled == true) {
        return "asdkasdj";
      }
    };
    const membershipList = ref([{
      sub_id: 25,
      name: "\u9752\u6625\u7248",
      price: "199",
      sub_model: [1, 2],
      permission: [],
      sj: 0
    }, {
      sub_id: 26,
      name: "\u521b\u4e1a\u677f",
      price: "399",
      sub_model: [1, 2, 3, 4],
      permission: [],
      sj: 0
    }, {
      sub_id: 27,
      name: "\u6807\u51c6\u7248",
      price: "999",
      sub_model: [1, 2, 3, 4, 5, 6, 7, 8],
      permission: [],
      sj: 0
    }, {
      sub_id: 28,
      name: "\u4ea7\u54c1\u5408\u4f19\u4eba",
      price: "1599",
      sub_model: [1, 2, 3, 4, 5, 6, 7, 8],
      permission: [],
      sj: 600
    }]);
    const disab_permission = ref([]);

    // 选中的会员类型索引
    const selectedIndex = ref(); // 默认选中第一个

    // 选择会员类型
    const selectMembership = (index, sje, sub_model, price) => {
      // if (index + 1 >= grow_up.value) {
      selectedIndex.value = index;
      disabledIndices.value = sub_model;
      taoc_price.value = price;
      sj.value = sje;
      jahfj.value = [];
      // }
    };
    const taoc_price = ref();
    const sj = ref();
    const sadfhj = a => {
      if (a === 0) {
        return " border-top-left-radius:0px ;";
      }
      if (a === 3) {
        return " border-top-right-radius:0px ;";
      }
    };

    /**
     * 九个功能
     *
     */
    const items = ref([{
      sub_id: 29,
      name: "\u4f5c\u4e1a\u6279\u6539",
      price: 168,
      sub_model: [3],
      permission: [1, 2],
      img: null
    }, {
      sub_id: 30,
      name: "\u4f5c\u4e1a\u7eb8",
      price: 199,
      sub_model: [4],
      permission: [1, 2],
      img: null
    }, {
      sub_id: 31,
      name: "\u56fe\u7247&\u6559\u5177",
      price: 199,
      sub_model: [5],
      permission: [1, 2],
      img: null
    }, {
      sub_id: 32,
      name: "\u9b54\u6cd5\u914d\u97f3",
      price: 199,
      sub_model: [6],
      permission: [1, 2],
      img: null
    }, {
      sub_id: 33,
      name: "\u5206\u7ea7\u9605\u8bfb",
      price: 99,
      sub_model: [7],
      permission: [1, 2],
      img: null
    }, {
      sub_id: 34,
      name: "\u53e3\u8bed\u6559\u7ec3",
      price: 99,
      sub_model: [8],
      permission: [1, 2],
      img: null
    }]);
    const ffshj = ref([{
      id: 1,
      name: "魔法工具",
      price: "199",
      icon: "	https://app.smartschool.chat/assets/img/microscope.72108a29.png"
    }, {
      id: 2,
      name: "与AI聊天",
      price: "199",
      icon: "https://app.smartschool.chat/assets/img/foreignteacher.817208da.png"
    }]);
    const ffshjwqeqw = ref([{
      id: 1,
      name: "定制化",
      price: "功能",
      icon: ruler
    }, {
      id: 2,
      name: "专属客服",
      price: "7*24小时",
      icon: dasdas
    }, {
      id: 3,
      name: "推广分成",
      price: "20%",
      icon: asdasdf
    }, {
      id: 3,
      name: "专属群",
      price: "工具 流量",
      icon: stickynotes
    }]);
    const safsaff = ref([{
      id: 1,
      name: "儿歌生成",
      price: "180首",
      icon: asdasddd
    }]);
    const disabledIndices = ref([]);

    //判断套餐包含的内容
    const jsdfksfj = a => {
      const isDisabled = disabledIndices.value.includes(a.sub_model[0]);
      if (isDisabled == false) {
        return "display: none;";
      }
    };
    //判断更多展示的内容
    const jsdfksfj2 = a => {
      const isDisabled = disabledIndices.value.includes(a.sub_model[0]);
      if (isDisabled == true) {
        return "display: none;";
      }
    };

    //判断用户可以购买的内容和选择好的内容
    const sdfhgs = a => {
      const isDisabled = disab_permission.value.includes(a.sub_model[0]);
      if (isDisabled == false) {
        // 根据元素是否存在于数组中来进行添加或删除操作
        const isDisableddas = jahfj.value.includes(a.sub_model[0]);
        if (isDisableddas) {
          // 如果存在，则删除
          jahfj.value = jahfj.value.filter(item => item !== a.sub_model[0]);
          console.log("删除", jahfj.value);
        } else {
          // 如果不存在，则添加
          jahfj.value.push(a.sub_model[0]);
          console.log("添加", jahfj.value);
        }
      }
    };
    //判断用户选择好的内容的展示和删除
    const dhjasgdja = a => {
      const isDisabled = jahfj.value.includes(a.sub_model[0]);
      if (isDisabled == true) {
        return `
    border: 3px solid #7a59ff;
  box-shadow: 4px 5px 4px rgb(0 0 0 / 10%);
    background: #ffffff;`;
      }
    };
    const jahfj = ref([]);
    const jsdhfgksd = index => {
      console.log("index", index);
      console.log("jahfj", jahfj.value.length);
      if (jahfj.value.length >= 2) {
        if (index == jahfj.value.length - 1) {
          return "=";
        } else {
          return "+";
        }
      }
      if (jahfj.value.length < 2) {
        return "=";
      }
    };

    // 判断总价格
    const jahsdgjaf = () => {
      if (jahfj.value.length == 0) {
        if (grow_up.value == 0) {
          return taoc_price.value;
        } else {
          return sj.value;
        }
      } else if (selectedIndex.value == grow_up.value - 1 && grow_up.value != 0) {
        const totalPrice = items.value.filter(item => jahfj.value.includes(item.sub_model[0])) // 判断sub_model[0]是否存在于jahfj
        .reduce((total, item) => total + parseFloat(item.price), 0); // 求和

        return totalPrice.toFixed(0);
      } else if (grow_up.value == 0) {
        const totalPrice = items.value.filter(item => jahfj.value.includes(item.sub_model[0])) // 判断sub_model[0]是否存在于jahfj
        .reduce((total, item) => total + parseFloat(item.price), 0); // 求和

        const totalPrice2d = totalPrice + Number(taoc_price.value);
        return totalPrice2d.toFixed(0);
      } else {
        console.log(sj.value);
        const totalPrice = items.value.filter(item => jahfj.value.includes(item.sub_model[0])) // 判断sub_model[0]是否存在于jahfj
        .reduce((total, item) => total + parseFloat(item.price), 0); // 求和

        const totalPrice2d = totalPrice + Number(sj.value);
        return totalPrice2d.toFixed(0);
      }
    };
    const findPriceBySubModel = subModel => {
      const foundItem = items.value.find(item => item.sub_model[0] === subModel);
      return foundItem ? foundItem.price : null;
    };
    const jdfhjs = () => {
      if (selectedIndex.value === grow_up.value - 1 && jahfj.value.length === 0) {
        ElMessage({
          message: "您已经购买此内容请重新选择",
          type: "warning"
        });
      } else {
        const askfjd = membershipList.value[selectedIndex.value].sub_id;
        // console.log('askfjd',askfjd);

        // 查找匹配的sub_id并输出排列后的数组
        const matchedSubIds = items.value.filter(item => jahfj.value.includes(item.sub_model[0])) // 筛选出匹配的item
        .map(item => item.sub_id) // 提取sub_id
        .sort(); // 排序

        if (selectedIndex.value != grow_up.value - 1) {
          matchedSubIds.unshift(askfjd);
        }

        // console.log("匹配的 sub_id 排列为:", matchedSubIds);
        jhasgdjas.value = matchedSubIds;
        sdfjhsdgfj();
      }
    };
    const jdfdasdhjs = () => {
      ElMessage({
        message: "您已经购买更高级的套餐请重新选择",
        type: "warning"
      });
    };
    // 微信支付弹窗
    const sdhjfgsdjh = ref(false); // 控制 dialog 显示
    const isOrderDetailOpen = ref(false); // 控制订单详情展开收起
    const asjkdhk = ref(); // 控制订单详情展开收起
    const jhasgdjas = ref(); // 控制订单详情展开收起
    const zfjzskdf = ref(false); // 控制订单详情展开收起

    let dasdf;
    const sdfjhsdgfj = () => {
      if (grow_up.value == 0) {
        var jahfj = paywechat;
      } else {
        var jahfj = ordersswitchingpost;
      }
      let data = {
        sub_id: jhasgdjas.value
      };
      jahfj(data).then(res => {
        asjdhj.value = true;
        zfjzskdf.value = false;
        asjkdhk.value = res.message;
        dasdf = setInterval(() => {
          let asjhj = {
            order_id: res.message.order_id
          };
          getordersts(asjhj).then(reee => {
            if (reee.message && reee.message.status === 4) {
              kjsdfksdf();
              zfjzskdf.value = true;
              setTimeout(function () {
                location.reload(); // 刷新页面
              }, 2000); // 3000毫秒，即3秒
            }
          });
        }, 2000);
        setTimeout(() => {
          clearInterval(dasdf);
          asjdhj.value = false;
        }, 90000);
        sdhjfgsdjh.value = true;
      });
    };
    const asjdhj = ref(true);
    const kjsdfksdf = () => {
      sdhjfgsdjh.value = false;
      clearInterval(dasdf);
    };
    const toggleOrderDetail = () => {
      isOrderDetailOpen.value = !isOrderDetailOpen.value;
    };
    return (_ctx, _cache) => {
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
        src: haye.value,
        alt: "",
        style: {
          "max-height": "100%",
          "border-radius": "50%",
          "border": "2px solid #e2ae38"
        }
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("p", _hoisted_6, _toDisplayString(name.value), 1), _createElementVNode("p", _hoisted_7, [grow_up.value == 1 ? (_openBlock(), _createElementBlock("span", _hoisted_8, "青春版用户")) : _createCommentVNode("", true), grow_up.value == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_9, "创业版用户")) : _createCommentVNode("", true), grow_up.value == 3 ? (_openBlock(), _createElementBlock("span", _hoisted_10, "标准版用户")) : _createCommentVNode("", true), grow_up.value == 4 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "产品合伙人")) : _createCommentVNode("", true), grow_up.value == 0 ? (_openBlock(), _createElementBlock("span", _hoisted_12, "免费用户")) : _createCommentVNode("", true)])]), _hoisted_13]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(membershipList.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["membership-item", {
            selected2: index + 1 > grow_up.value,
            selected: selectedIndex.value === index
          }]),
          style: _normalizeStyle([sadfhj(index)]),
          onClick: $event => selectMembership(index, item.sj, item.sub_model, item.price)
        }, [_createElementVNode("div", {
          class: _normalizeClass(["item-title", {
            'selected-text': selectedIndex.value === index
          }])
        }, _toDisplayString(item.name), 3), _createElementVNode("div", {
          class: _normalizeClass(["item-description", {
            'selected-text': selectedIndex.value === index
          }])
        }, [_hoisted_16, Number(grow_up.value) - 1 >= index ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(item.price) + "元/年 ", 1)) : _createCommentVNode("", true), Number(grow_up.value) - 1 < index && grow_up.value != 0 ? (_openBlock(), _createElementBlock("p", _hoisted_18, [_hoisted_19, _createTextVNode(" " + _toDisplayString(item.sj) + "元/年 ", 1), _createElementVNode("span", _hoisted_20, _toDisplayString(item.price) + "元/年", 1)])) : _createCommentVNode("", true), grow_up.value == 0 ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(item.price) + "元/年 ", 1)) : _createCommentVNode("", true), index + 1 == grow_up.value ? (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_24)) : _createCommentVNode("", true)], 2)], 14, _hoisted_15);
      }), 128))]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_hoisted_27, _createElementVNode("div", _hoisted_28, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(ffshj.value, box => {
        return _openBlock(), _createElementBlock("div", {
          class: "box1",
          key: box.id
        }, [_hoisted_29, _createElementVNode("img", {
          src: box.icon,
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_30), _createElementVNode("div", _hoisted_31, _toDisplayString(box.name), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(box.price) + "元/年", 1)]);
      }), 128)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, box => {
        return _openBlock(), _createElementBlock("div", {
          class: "box1",
          key: box.id,
          style: _normalizeStyle(jsdfksfj(box))
        }, [_hoisted_33, box.name == '英语作业纸' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(explanations),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_34)) : _createCommentVNode("", true), box.name == '作业批改' ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _unref(proofreader),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_35)) : _createCommentVNode("", true), box.name == '魔法配音' ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: _unref(generator),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_36)) : _createCommentVNode("", true), box.name == '图片&教具' ? (_openBlock(), _createElementBlock("img", {
          key: 3,
          src: _unref(bunz),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_37)) : _createCommentVNode("", true), box.name == '口语教练' ? (_openBlock(), _createElementBlock("img", {
          key: 4,
          src: _unref(observation),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_38)) : _createCommentVNode("", true), box.name == '分级阅读' ? (_openBlock(), _createElementBlock("img", {
          key: 5,
          src: _unref(swdtsna),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_39)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_40, _toDisplayString(box.name), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(box.price) + "元/年", 1)], 4);
      }), 128)), selectedIndex.value == 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(safsaff.value, box => {
        return _openBlock(), _createElementBlock("div", {
          class: "box1",
          key: box.id
        }, [_hoisted_42, _createElementVNode("img", {
          src: box.icon,
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_43), _createElementVNode("div", _hoisted_44, _toDisplayString(box.name), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(box.price), 1)]);
      }), 128)) : _createCommentVNode("", true), selectedIndex.value == 3 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 1
      }, _renderList(ffshjwqeqw.value, box => {
        return _openBlock(), _createElementBlock("div", {
          class: "box1_1",
          key: box.id
        }, [_hoisted_46, _createElementVNode("img", {
          src: box.icon,
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_47), _createElementVNode("div", _hoisted_48, _toDisplayString(box.name), 1), _createElementVNode("div", _hoisted_49, _toDisplayString(box.price), 1)]);
      }), 128)) : _createCommentVNode("", true)])]), selectedIndex.value != 2 && selectedIndex.value != 3 ? (_openBlock(), _createElementBlock("div", _hoisted_50, [_hoisted_51, _createElementVNode("div", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, box => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["box", dhjsfg(box)]),
          key: box.id,
          style: _normalizeStyle([jsdfksfj2(box), dhjasgdja(box)]),
          onClick: $event => sdfhgs(box)
        }, [_createElementVNode("div", _hoisted_54, [dhjasgdja(box) == `
    border: 3px solid #7a59ff;
  box-shadow: 4px 5px 4px rgb(0 0 0 / 10%);
    background: #ffffff;` ? (_openBlock(), _createElementBlock("svg", _hoisted_55, _hoisted_57)) : _createCommentVNode("", true), dhjsfg(box) == 'asdkasdj' ? (_openBlock(), _createElementBlock("svg", _hoisted_58, _hoisted_60)) : _createCommentVNode("", true)]), box.name == '英语作业纸' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(explanations),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_61)) : _createCommentVNode("", true), box.name == '作业批改' ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _unref(proofreader),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_62)) : _createCommentVNode("", true), box.name == '魔法配音' ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          src: _unref(generator),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_63)) : _createCommentVNode("", true), box.name == '图片&教具' ? (_openBlock(), _createElementBlock("img", {
          key: 3,
          src: _unref(bunz),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_64)) : _createCommentVNode("", true), box.name == '口语教练' ? (_openBlock(), _createElementBlock("img", {
          key: 4,
          src: _unref(observation),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_65)) : _createCommentVNode("", true), box.name == '分级阅读' ? (_openBlock(), _createElementBlock("img", {
          key: 5,
          src: _unref(swdtsna),
          alt: "",
          style: {
            "width": "40%"
          }
        }, null, 8, _hoisted_66)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_67, _toDisplayString(box.name), 1), _createElementVNode("div", _hoisted_68, "￥" + _toDisplayString(box.price) + "元/年", 1)], 14, _hoisted_53);
      }), 128))])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("p", null, [_createElementVNode("span", _hoisted_71, [_createElementVNode("span", null, _toDisplayString(selectedIndex.value + 1 > grow_up.value && grow_up.value != 0 ? '升级' : ''), 1), _createTextVNode("费用： ")]), jahfj.value.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_72, [taoc_price.value ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(grow_up.value != 0 ? `${sj.value}+` : null) + " " + _toDisplayString(grow_up.value == 0 ? `${taoc_price.value}+` : null), 1)) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jahfj.value, (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          key: index
        }, [_createTextVNode(_toDisplayString(findPriceBySubModel(item)) + " ", 1), _createElementVNode("span", null, _toDisplayString(jsdhfgksd(index)), 1)]);
      }), 128))])) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_74, _toDisplayString(jahsdgjaf() < 0 ? 0 : jahsdgjaf()), 1), _hoisted_75]), _hoisted_76]), grow_up.value <= selectedIndex.value + 1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "erwwl_2",
        onClick: _cache[0] || (_cache[0] = $event => jdfhjs())
      }, _hoisted_78)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "erwwl_23",
        onClick: _cache[1] || (_cache[1] = $event => jdfdasdhjs())
      }, _hoisted_80))])]), _createVNode(_component_el_dialog, {
        modelValue: sdhjfgsdjh.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => sdhjfgsdjh.value = $event),
        title: "订单支付",
        width: "500px",
        style: {
          "border-radius": "10px"
        },
        "close-on-click-modal": false,
        "before-close": kjsdfksdf,
        class: "payment-dialog"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_81, [_createElementVNode("p", _hoisted_82, [_createTextVNode(" 商品订单："), _createElementVNode("span", _hoisted_83, _toDisplayString(asjkdhk.value.order_id), 1)]), _createElementVNode("p", _hoisted_84, [_createTextVNode(" 支付金额："), _createElementVNode("span", _hoisted_85, "￥" + _toDisplayString(asjkdhk.value.money), 1)])]), _createElementVNode("div", _hoisted_86, [_hoisted_87, _createElementVNode("div", _hoisted_88, [_createElementVNode("div", _hoisted_89, [_hoisted_90, _hoisted_91, _createVNode(_unref(ElIcon), {
          class: "selected-icon"
        }, {
          default: _withCtx(() => [_createVNode(_unref(Check))]),
          _: 1
        })])])]), _createVNode(_component_el_divider), _createElementVNode("div", _hoisted_92, [_createElementVNode("div", _hoisted_93, [asjdhj.value ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: asjkdhk.value.qr_code_image,
          alt: "微信支付二维码",
          class: "qr-code-img"
        }, null, 8, _hoisted_94)) : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "qr-code-img",
          onClick: sdfjhsdgfj
        }, [(_openBlock(), _createElementBlock("svg", _hoisted_95, _hoisted_97)), _hoisted_98])), _hoisted_99]), _hoisted_100])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
        modelValue: zfjzskdf.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => zfjzskdf.value = $event),
        title: "",
        width: "300",
        style: {
          "border-radius": "10px"
        },
        "close-on-click-modal": false,
        "show-close": false
      }, {
        default: _withCtx(() => [_hoisted_101]),
        _: 1
      }, 8, ["modelValue"])], 64);
    };
  }
};